import React from 'react';


const GratuityStatusCard = ({statusTitle, noOfOrders, dropDown2, salesRevenue, noOfOrdersClassName, dropDown}) => {



    return (
        <section>
            <div className='order-status-card-container sales-status-card gratuity-status-card'>
                <div className='flex gap-4'>
                    {/* <div>{icon}</div> */}
                    <p className='due-text'>{statusTitle}</p>
                    <section className='flex gap-4 ml-10'>
                        <section className='gratuity-dropdown'>
                            {dropDown}
                        </section>
                        <section className='gratuity-dropdown'>
                            {dropDown2}
                        </section>
                    </section>
                    
                </div>
                <div className='flex flex-col gap-20 mt-7'>
                    <div>
                        <p className={`no-of-orders ${noOfOrdersClassName}`}>{salesRevenue}</p>
                    </div>
                    
                </div>
                <div className='customer-active-section'>
                    <p className='size mt-2'>{noOfOrders} <span className='customer-active-text'>{noOfOrders === 1 ? 'order' : 'orders'}</span> </p>
                </div>
            </div>
        </section>
    );
}

export default GratuityStatusCard;
